const MOBILE_QUERY = '(max-width: 768px)';
const MOBILE_WALLETS = ['paypal'];

/**
 * Mounts Shopify accelerated checkout buttons from a <template>.
 * On mobile, wallet-configs is filtered to MOBILE_WALLETS before the element connects,
 * because Shopify renders each wallet row inside a closed shadow root.
 */
class ReudynCheckoutButtons extends HTMLElement {
  #mounted = false;

  connectedCallback() {
    if (this.#mounted) return;

    const template = this.querySelector(':scope > template');
    if (!template) return;

    this.#mounted = true;
    const fragment = /** @type {DocumentFragment} */ (template.content.cloneNode(true));

    if (window.matchMedia(MOBILE_QUERY).matches) {
      fragment.querySelectorAll('shopify-accelerated-checkout-cart[wallet-configs]').forEach((el) => {
        filterWallets(el);
      });
    }

    this.append(fragment);
  }
}

/** @param {Element} el */
function filterWallets(el) {
  let configs;
  try {
    configs = JSON.parse(el.getAttribute('wallet-configs') || '[]');
  } catch {
    return;
  }
  if (!Array.isArray(configs)) return;

  const kept = configs.filter((config) => MOBILE_WALLETS.includes(config?.name));
  if (!kept.length || kept.length === configs.length) return;

  el.setAttribute('wallet-configs', JSON.stringify(kept));

  const cells = el.querySelectorAll('.wallet-cart-grid--skeleton > li');
  for (let i = kept.length; i < cells.length; i++) cells[i]?.remove();
}

if (!customElements.get('reudyn-checkout-buttons')) {
  customElements.define('reudyn-checkout-buttons', ReudynCheckoutButtons);
}
